import React, { useState } from "react";
import { UpdateDistributor } from "./UpdateDistributor";
import { Button } from "../ui/Button";
import { Dialog } from "primereact/dialog";

type UpdateDistributorModalProps = {
  distributorId: number;
};

export function UpdateDistributorModal({
  distributorId,
}: UpdateDistributorModalProps) {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button onClick={() => setVisible(true)}>Edit</Button>
      <Dialog
        visible={visible}
        header="Edit"
        className="p-fluid tablet:max-w-xl tablet:w-full"
        onHide={() => setVisible(false)}
        modal
      >
        <UpdateDistributor
          distributorId={distributorId}
          onUpdate={() => setVisible(false)}
        />
      </Dialog>
    </>
  );
}
